/**
 * Ingredients tabs — panel swap (buy column) or filter (#formula section).
 */
(function () {
  "use strict";

  // Ingredient sticker images are stored as theme assets named
  // "fb-images-ingredients-<file>". The petri JSON only holds the bare
  // "<file>" name, so we rebuild the real Shopify asset URL at runtime by
  // borrowing the theme's own /assets/ path already present on the page.
  var ASSET_BASE = null;
  function assetBase() {
    if (ASSET_BASE !== null) return ASSET_BASE;
    var el =
      document.querySelector('script[src*="fb-pdp-ingredients-tabs.js"]') ||
      document.querySelector('img[src*="/assets/fb-images-ingredients-"]') ||
      document.querySelector('link[href*="/assets/"]');
    var url = el ? el.src || el.href || "" : "";
    url = url.split("?")[0];
    ASSET_BASE = url ? url.slice(0, url.lastIndexOf("/") + 1) : "";
    return ASSET_BASE;
  }

  function ingredientImageUrl(img) {
    if (!img) return "";
    return assetBase() + "fb-images-ingredients-" + img;
  }

  function initPanelTabs(root) {
    var buttons = root.querySelectorAll(".tabs-button");
    var panels = root.querySelectorAll(".tabs-wrapper");

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var panelId = btn.getAttribute("data-wrapper-id");
        buttons.forEach(function (b) {
          b.classList.toggle("is-active", b === btn);
        });
        panels.forEach(function (panel) {
          panel.classList.toggle("hidden", panel.id !== panelId);
        });
      });
    });
  }

  function updateIngredientCount(root) {
    var counter = root.querySelector("[data-ingredient-count]");
    if (!counter) return;
    var inFilter = root.querySelectorAll("[data-ingredient-categories]:not([hidden])");
    var visible = root.querySelectorAll(
      "[data-ingredient-categories]:not([hidden]):not(.is-collapsed-hidden)"
    );
    var n = visible.length;
    var total = inFilter.length;
    if (n < total) {
      counter.textContent = "Showing " + n + " of " + total + " ingredients";
    } else {
      counter.textContent =
        n === 1 ? "Showing 1 ingredient" : "Showing " + n + " ingredients";
    }
  }

  function closeFormulaBubble() {
    var bubbleRoot = document.getElementById("v4-ingredient-bubble");
    var section = document.getElementById("formula");
    if (!bubbleRoot || bubbleRoot.getAttribute("data-open") !== "true") return;
    bubbleRoot.innerHTML = "";
    bubbleRoot.setAttribute("data-open", "false");
    bubbleRoot.setAttribute("aria-hidden", "true");
    if (section) {
      section.querySelectorAll(".card-collapsible[data-active]").forEach(function (card) {
        card.removeAttribute("data-active");
      });
      section.querySelectorAll(".card-collapsible__trigger[aria-expanded='true']").forEach(function (btn) {
        btn.setAttribute("aria-expanded", "false");
      });
    }
  }

  function initFilterTabs(root) {
    var buttons = root.querySelectorAll(".tabs-button");
    var cards = root.querySelectorAll("[data-ingredient-categories]");
    var block = root.querySelector("[data-collapsible-cards]");

    function applyFilter(filter) {
      closeFormulaBubble();
      cards.forEach(function (card) {
        var cats = card.getAttribute("data-ingredient-categories") || "";
        var show = filter === "all" || (" " + cats + " ").indexOf(" " + filter + " ") !== -1;
        card.hidden = !show;
        card.classList.remove("is-collapsed-hidden");
      });
      if (block) {
        block.classList.remove("is-expanded");
        updateShowMore(block);
      }
      updateIngredientCount(root);
    }

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var filter = btn.getAttribute("data-filter") || "all";
        buttons.forEach(function (b) {
          b.classList.toggle("is-active", b === btn);
        });
        applyFilter(filter);
      });
    });

    applyFilter("all");
  }

  function visibleCards(block) {
    return Array.prototype.filter.call(
      block.querySelectorAll(".card-collapsible"),
      function (card) {
        return !card.hidden;
      }
    );
  }

  function showMoreLimit(block) {
    var raw = block.getAttribute("data-show-more-limit");
    var n = raw ? parseInt(raw, 10) : 4;
    return Number.isFinite(n) && n > 0 ? n : 4;
  }

  function updateShowMore(block) {
    var moreWrap = block.querySelector(".collapsible-cards__more");
    var showMore = moreWrap ? moreWrap.querySelector("[data-show-more]") : null;
    var showLess = moreWrap ? moreWrap.querySelector("[data-show-less]") : null;
    var limit = showMoreLimit(block);
    var shown = visibleCards(block);
    var expanded = block.classList.contains("is-expanded");

    if (!moreWrap || shown.length <= limit) {
      if (moreWrap) {
        moreWrap.hidden = true;
        moreWrap.setAttribute("aria-hidden", "true");
      }
      block.classList.remove("is-expanded");
      shown.forEach(function (card) {
        card.classList.remove("is-collapsed-hidden");
      });
      if (showMore) showMore.hidden = false;
      if (showLess) showLess.hidden = true;
      return;
    }

    moreWrap.hidden = false;
    moreWrap.setAttribute("aria-hidden", "false");
    shown.forEach(function (card, i) {
      if (!expanded && i >= limit) {
        card.classList.add("is-collapsed-hidden");
      } else {
        card.classList.remove("is-collapsed-hidden");
      }
    });

    var hiddenCount = shown.length - limit;
    if (showMore) {
      showMore.hidden = expanded;
      if (!expanded) {
        showMore.textContent =
          hiddenCount === 1
            ? "Show 1 more ingredient"
            : "Show " + hiddenCount + " more ingredients";
      }
    }
    if (showLess) {
      showLess.hidden = !expanded;
    }
  }

  function initShowMore(root) {
    root.querySelectorAll("[data-collapsible-cards]").forEach(function (block) {
      var moreWrap = block.querySelector(".collapsible-cards__more");
      var showMore = moreWrap ? moreWrap.querySelector("[data-show-more]") : null;
      var showLess = moreWrap ? moreWrap.querySelector("[data-show-less]") : null;

      updateShowMore(block);

      if (showMore) {
        showMore.addEventListener("click", function () {
          block.classList.add("is-expanded");
          block.querySelectorAll(".is-collapsed-hidden").forEach(function (el) {
            el.classList.remove("is-collapsed-hidden");
          });
          updateShowMore(block);
          var tabsRoot = block.closest("[data-ingredients-tabs]");
          if (tabsRoot) updateIngredientCount(tabsRoot);
        });
      }
      if (showLess) {
        showLess.addEventListener("click", function () {
          block.classList.remove("is-expanded");
          updateShowMore(block);
          var tabsRoot = block.closest("[data-ingredients-tabs]");
          if (tabsRoot) updateIngredientCount(tabsRoot);
        });
      }

      var tabsRoot = block.closest("[data-ingredients-tabs]");
      if (tabsRoot) updateIngredientCount(tabsRoot);
    });
  }

  function initFormulaBubble(section) {
    if (!section || !section.classList.contains("ut-ingredients")) return;

    var dataEl = document.getElementById("petri-ingredients-data");
    var bubbleRoot = document.getElementById("v4-ingredient-bubble");
    if (!dataEl || !bubbleRoot) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent || "");
    } catch (e) {
      return;
    }

    var stickersBySlug = {};
    (data.stickers || []).forEach(function (s) {
      stickersBySlug[s.slug] = s;
    });
    var details = data.details || {};
    var activeSlug = null;

    function cardEls() {
      return section.querySelectorAll(".card-collapsible[data-ingredient-slug]");
    }

    function triggerEls() {
      return section.querySelectorAll(".card-collapsible__trigger[data-ingredient-slug]");
    }

    function setCardState() {
      cardEls().forEach(function (card) {
        var slug = card.getAttribute("data-ingredient-slug");
        if (slug === activeSlug) {
          card.setAttribute("data-active", "true");
        } else {
          card.removeAttribute("data-active");
        }
      });
      triggerEls().forEach(function (btn) {
        var slug = btn.getAttribute("data-ingredient-slug");
        btn.setAttribute("aria-expanded", slug === activeSlug ? "true" : "false");
      });
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function isMobileIngredientView() {
      return window.matchMedia("(max-width: 720px)").matches;
    }

    function headerScrollPadding() {
      var root = document.documentElement;
      var styles = getComputedStyle(root);
      var headerH = parseFloat(styles.getPropertyValue("--v4-header-h")) || 72;
      return headerH + 20;
    }

    function bubbleBottomPadding() {
      var padBottom = 24;
      var stickyBar = document.querySelector(".v4-pdp-sticky-bar.--visible");
      if (stickyBar) {
        padBottom = Math.max(padBottom, stickyBar.getBoundingClientRect().height + 16);
      }
      var footer = document.querySelector(".fb-site-footer");
      if (footer) {
        var footerTop = footer.getBoundingClientRect().top;
        var viewH = window.innerHeight;
        if (footerTop < viewH) {
          padBottom = Math.max(padBottom, viewH - footerTop + 16);
        }
      }
      return padBottom;
    }

    function scrollBubbleIntoView(behaviorOverride) {
      var card = bubbleRoot.querySelector(".v4-ingredient-bubble__card");
      if (!card) return;

      var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var mobile = isMobileIngredientView();
      var behavior = behaviorOverride || (reduced || mobile ? "auto" : "smooth");
      var padTop = headerScrollPadding();

      // Mobile: always jump so the card top sits below the header — skip footer padding.
      if (mobile) {
        var mobileRect = card.getBoundingClientRect();
        window.scrollTo({
          top: Math.max(0, window.scrollY + mobileRect.top - padTop),
          behavior: behavior,
        });
        return;
      }

      var padBottom = bubbleBottomPadding();
      var viewH = window.innerHeight;
      var maxVisible = viewH - padTop - padBottom;
      var rect = card.getBoundingClientRect();
      var nextScrollY = window.scrollY;
      var safeBottom = viewH - padBottom;

      if (rect.height <= maxVisible) {
        if (rect.top < padTop) {
          nextScrollY += rect.top - padTop;
        } else if (rect.bottom > safeBottom) {
          nextScrollY += rect.bottom - safeBottom;
        }
      } else if (rect.top < padTop) {
        nextScrollY += rect.top - padTop;
      } else if (rect.bottom > safeBottom) {
        nextScrollY += Math.min(rect.bottom - safeBottom, rect.top - padTop);
      }

      if (Math.abs(nextScrollY - window.scrollY) > 1) {
        window.scrollTo({ top: Math.max(0, nextScrollY), behavior: behavior });
      }
    }

    function afterBubbleOpen(fn) {
      var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var mobile = isMobileIngredientView();
      if (reduced) {
        window.requestAnimationFrame(fn);
        return;
      }
      // Wait for the grid expand transition before measuring scroll position.
      var delay = mobile ? 420 : 400;
      window.setTimeout(function () {
        window.requestAnimationFrame(fn);
        if (mobile) {
          window.setTimeout(function () {
            window.requestAnimationFrame(fn);
          }, 150);
        }
      }, delay);
    }

    function renderBubble(slug) {
      var sticker = stickersBySlug[slug];
      var detail = details[slug];
      if (!sticker || !detail) return "";

      var citations = (detail.citations || [])
        .map(function (c) {
          return (
            '<li><a href="' +
            escapeHtml(c.url) +
            '" target="_blank" rel="noopener noreferrer" aria-label="See study, PubMed ID ' +
            escapeHtml(c.pmid) +
            ', opens in new tab">See study <span aria-hidden="true">↗</span><span class="v4-ingredient-bubble__pmid">PMID ' +
            escapeHtml(c.pmid) +
            "</span></a></li>"
          );
        })
        .join("");

      var paragraphs = (detail.paragraphs || [])
        .map(function (p) {
          return "<p>" + escapeHtml(p) + "</p>";
        })
        .join("");

      var badge = detail.unique
        ? '<span class="v4-ingredient-bubble__badge">Unique to BC</span>'
        : "";

      var citationsBlock = citations
        ? '<ul class="v4-ingredient-bubble__citations">' + citations + "</ul>"
        : "";

      var latinHtml = sticker.latin
        ? '<em class="v4-ingredient-bubble__latin">' + escapeHtml(sticker.latin) + "</em>"
        : "";

      return (
        '<article class="v4-ingredient-bubble__card v4-ingredient-bubble__card--' +
        escapeHtml(detail.group) +
        '" role="region" aria-labelledby="v4-ingredient-bubble-name">' +
        '<button type="button" class="v4-ingredient-bubble__close" aria-label="Close ingredient detail">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">' +
        '<line x1="2" y1="2" x2="12" y2="12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '<line x1="12" y1="2" x2="2" y2="12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        "</svg></button>" +
        '<span class="v4-ingredient-bubble__plate" aria-hidden="true">' +
        '<img src="' +
        escapeHtml(ingredientImageUrl(sticker.img)) +
        '" alt="" loading="lazy" width="200" height="200">' +
        "</span>" +
        '<div class="v4-ingredient-bubble__content">' +
        '<p class="v4-ingredient-bubble__group-label"><span aria-hidden="true">●</span> ' +
        escapeHtml(detail.groupLabel) +
        badge +
        "</p>" +
        '<h3 id="v4-ingredient-bubble-name" class="v4-ingredient-bubble__name">' +
        escapeHtml(detail.fullName) +
        latinHtml +
        "</h3>" +
        '<p class="v4-ingredient-bubble__dose">' +
        escapeHtml(detail.dose) +
        "</p>" +
        '<p class="v4-ingredient-bubble__lead">' +
        escapeHtml(detail.lead) +
        "</p>" +
        '<div class="v4-ingredient-bubble__body">' +
        paragraphs +
        "</div>" +
        citationsBlock +
        "</div></article>"
      );
    }

    function closeIngredient() {
      activeSlug = null;
      bubbleRoot.innerHTML = "";
      bubbleRoot.setAttribute("data-open", "false");
      bubbleRoot.setAttribute("aria-hidden", "true");
      setCardState();
    }

    function openIngredient(slug) {
      activeSlug = slug;
      bubbleRoot.innerHTML = renderBubble(slug);
      bubbleRoot.setAttribute("data-open", "true");
      bubbleRoot.setAttribute("aria-hidden", "false");
      setCardState();
      var closeBtn = bubbleRoot.querySelector(".v4-ingredient-bubble__close");
      if (closeBtn) closeBtn.addEventListener("click", closeIngredient);
      afterBubbleOpen(function () {
        scrollBubbleIntoView();
        var card = bubbleRoot.querySelector(".v4-ingredient-bubble__card");
        var img = card && card.querySelector(".v4-ingredient-bubble__plate img");
        if (img && !img.complete) {
          img.addEventListener(
            "load",
            function () {
              scrollBubbleIntoView("auto");
            },
            { once: true }
          );
        }
      });
    }

    function toggleIngredient(slug) {
      if (activeSlug === slug) {
        closeIngredient();
      } else {
        openIngredient(slug);
      }
    }

    triggerEls().forEach(function (btn) {
      btn.addEventListener("click", function () {
        toggleIngredient(btn.getAttribute("data-ingredient-slug"));
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && activeSlug) closeIngredient();
    });

    document.addEventListener("mousedown", function (e) {
      if (!activeSlug) return;
      if (bubbleRoot.contains(e.target)) return;
      if (e.target.closest && e.target.closest(".card-collapsible__trigger")) return;
      closeIngredient();
    });

    setCardState();
  }

  function initCardTilt(section) {
    if (!section || !section.classList.contains("ut-ingredients")) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var maxTilt = 4;

    section.querySelectorAll(".card-collapsible--stat").forEach(function (card) {
      var trigger = card.querySelector(".card-collapsible__trigger");
      if (!trigger) return;

      function setTilt(clientX, clientY) {
        var rect = card.getBoundingClientRect();
        var x = (clientX - rect.left) / rect.width - 0.5;
        var y = (clientY - rect.top) / rect.height - 0.5;
        var rotY = x * maxTilt * 2;
        var rotX = -y * maxTilt * 2;
        card.style.setProperty("--card-tilt-x", rotX.toFixed(2) + "deg");
        card.style.setProperty("--card-tilt-y", rotY.toFixed(2) + "deg");
      }

      function resetTilt() {
        card.classList.remove("is-tilting");
        card.style.setProperty("--card-tilt-x", "0deg");
        card.style.setProperty("--card-tilt-y", "0deg");
      }

      trigger.addEventListener("mouseenter", function (e) {
        card.classList.add("is-tilting");
        setTilt(e.clientX, e.clientY);
      });

      trigger.addEventListener("mousemove", function (e) {
        setTilt(e.clientX, e.clientY);
      });

      trigger.addEventListener("mouseleave", resetTilt);
    });
  }

  function boot() {
    var formula = document.getElementById("formula");
    initFormulaBubble(formula);
    initCardTilt(formula);

    document.querySelectorAll("[data-ingredients-tabs]").forEach(function (root) {
      if (root.hasAttribute("data-ingredients-filter")) {
        initFilterTabs(root);
      } else {
        initPanelTabs(root);
      }
      initShowMore(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
